import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../../commons/services/bringoz-loader.service";
import {ReportsRequests} from "../../../services/reports-requests.service";
import {CommonsAlertsService} from "../../../../commons/services/commons-alerts.service";
import {ResizeService} from "../../../../commons/services/resize-service.service";
import {DateRangeTimeFiltersService} from "../../../../commons/services/date-range-time-filters.service";

declare let google: any;

export class ReportsDeliveriesCompletionShipperCtrl implements IController {
  from: any;
  to: any;

  private colorByStatus: any;
  private mainDataTable: any;
  private totalsDataTable: any;
  private totals: any;
  private limit: any;
  private offset: any;
  private groupBy: any;
  private filterConfig: any;
  private expend: any;
  private flex: any;
  private dataTableRowsCount: any;


  /* @ngInject */
  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private reportsRequests: ReportsRequests, private chartColors,
              private bringozLoaderService: BringozLoaderService, private $log, private commonsAlertsService: CommonsAlertsService,
              private resizeService: ResizeService, private $state) {
    this.colorByStatus = this.chartColors.defaultColors;
  }

  $onInit() {
    this.totals = {};

    this.filterConfig = {
      from: undefined,
      to: undefined,
      branchId: undefined,
      demandIds: []
    };

    this.expend = {
      top: true,
      bottom: false
    };

    this.flex = {
      top: undefined,
      bottom: 'none'
    };

    this.groupBy = 'name';

    this.filterConfig = {
      from: this.from ? this.from : this.dateRangeTimeFiltersService.lastMonth().dateStart,
      to: this.to ? this.to : this.dateRangeTimeFiltersService.lastMonth().dateEnd,
      branchId: undefined,
      demandIds: [],
      range: this.from && this.to ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.lastMonth(),
      customTemplates: this.dateRangeTimeFiltersService.getReportCustomTemplates()
    };

    this._generateReports()
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onRangeChanged(range) {
    this.filterConfig.range = range;
    this.$state.go('.', {from: range.dateStart, to: range.dateEnd}, {notify: false, reload: false});
    this._generateReports();
  }

  onFiltersChange(branchId, demandIds) {
    this.filterConfig.branchId = branchId;
    this.filterConfig.demandIds = demandIds;
    this._generateReports();
  }

  onChangeGroupBy(groupBy) {
    this.groupBy = groupBy;
    this._generateReports();
  }

  onExport(event) {
    const payload = this._getQueryPayload();
    this.bringozLoaderService.on();
    this.reportsRequests.exportDeliveriesCompletion(payload.from, payload.to, 'shipper', this.groupBy,
      payload.branchId, payload.demandIds)
      .then((file) => {
        this.commonsAlertsService.exportToMailSuccess();
      })
      .catch((error) => {
        this.commonsAlertsService.exportToMailError();
        this.$log.error('Failed to export file', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onToggleExpend(sectionExpended) {
    this.expend[sectionExpended] = !this.expend[sectionExpended];
    this.flex[sectionExpended] = this.expend[sectionExpended] ? undefined : 'none';
    this.resizeService.resize();
  }

  onBack() {
    this.offset -= this.limit;
    this._setMainReport();
  }

  onNext() {
    this.offset += this.limit;
    this._setMainReport();
  }

  private _generateReports() {
    this.limit = 20;
    this.offset = 0;
    this._setMainReport();
    this._setTotals()
  }

  private _setMainReport() {
    const payload = this._getQueryPayload();
    const tq = 'limit ' + this.limit + ' offset ' + this.offset;

    this.bringozLoaderService.on();
    this.mainDataTable = undefined;
    this.dataTableRowsCount = 0;
    this.reportsRequests.getDeliveriesCompletionReport(tq, payload.from, payload.to, 'shipper', this.groupBy,
      payload.branchId, payload.demandIds)
      .then((data) => {
        this.dataTableRowsCount = _.get(data, 'rows.length', 0);
        if (data.rows && data.rows.length) {
          this.mainDataTable = new google.visualization.DataTable(data);
        }
      })
      .catch((error) => {
        this.$log.error('Failed to query main report @reportsDeliveriesCompletionShipper@_setMainReport', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _setTotals() {
    const payload = this._getQueryPayload();

    this.totalsDataTable = undefined;

    // For Chart View
    this.totals = undefined;

    this.bringozLoaderService.on();
    this.reportsRequests.getDeliveriesCompletionReport(undefined, payload.from, payload.to, 'shipper', this.groupBy,
      payload.branchId, payload.demandIds)
      .then((totalsData) => {

        // Total
        let totalsDataTable = new google.visualization.DataTable(angular.copy(totalsData));
        totalsDataTable.removeColumn(5);
        this.totalsDataTable = totalsDataTable;

        // For Chart View
        this.totals = this._getTotals(totalsData);

      })
      .catch((error) => {
        this.$log.error('Failed to get reports deliveries total @reportsSiteDeliveries@_setTotals', error);
        this.commonsAlertsService.somethingWentWrongError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private _getQueryPayload() {
    return {
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      branchId: this.filterConfig.branchId,
      demandIds: this.filterConfig.demandIds?.length ? this.filterConfig.demandIds : undefined
    }
  }

  private _getTotals(totalsDataTable) {
    const totals = {};
    _.forEach(totalsDataTable.cols, (col, index) => {
      if (col.type === "number") {
        totals[col.id] = _.sumBy(totalsDataTable.rows, (row: any) => {
          return row.c[index].v;
        });
      }
    });
    return totals;
  }

}

angular
  .module('bringoz.admin.reports')
  .component('reportsDeliveriesCompletionShipper', {
    bindings: {
      from: '<',
      to: '<'
    },
    template: require('./reports-deliveries-completion-shipper.html').default,
    controller: ReportsDeliveriesCompletionShipperCtrl
  });
